<template>
    <star-rating class="my-2" :value="stars" :read-only="true" />
</template>

<script>
import starRating from '../../../../generic/star-rating/star-rating.vue';
export default {
    components: {
        starRating,
    },
    computed: {
        stars() {
            return this.params.data ? this.params.data.stars : 0;
        },
    },
};
</script>
